import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'

import { getCompanyDashboardDataV2 } from '@data'
import { showLoader } from '@data/state/action'
import { MB_ROLES, supplyUserType } from '@constants'
import SalesDashboard from '../SalesDashboard'

const SupperSale = ({ dashboardType }) => {
	const user = useSelector((state) => state.getIn(['user', 'user']))
	const [recordsSales, SetRecordSales] = useState()
	const { pathname, search } = useLocation()
	const dispatch = useDispatch()

	const [accessType, numMonths, employeeId, fromMonth, toMonth, organisationId, platform] = useMemo(() => {
		const params = new URLSearchParams(search)
		let _accessType = !params?.get('employee_id') || params?.get('employee_id') === 'ALL' ? supplyUserType[1]?.name : supplyUserType[0]?.name
		let _numMonths = params?.get('numMonths') ?? 1
		let _employeeId = params?.get('employee_id') ?? null
		let _fromMonth = params?.get('from_date')
		let _toMonth = params?.get('to_date')
		let _orgId = params?.get('organisation')
		let _platform = params?.get('platform')
		return [_accessType, _numMonths, _employeeId, _fromMonth, _toMonth, _orgId, _platform]
	}, [search])

	useEffect(() => {
		dispatch(showLoader(true))
		getCompanyDashboardDataV2(
			employeeId === 'ALL' ? null : employeeId,
			dashboardType,
			fromMonth,
			toMonth,
			organisationId,
			user?.user_id,
			true,
			platform
		)
			.then((data) => {
				SetRecordSales(data)
			})
			.catch((err) => {
				console.log(err)
			})
			.finally(() => {
				dispatch(showLoader(false))
			})
	}, [dashboardType, accessType, numMonths, employeeId, organisationId, fromMonth, toMonth, platform])

	if (dashboardType === MB_ROLES.SALES) return <SalesDashboard data={recordsSales} hasOrganisationId={!!organisationId} />
}
export default SupperSale
